import api from '../app/api'
import { transformForApiRequest } from './order'

function transformResponse(response) {
    return response
        .then((data) => ({
            result: data.response.data.payload.valid,
            errormessage: data.response.data.payload.errormessage ? data.response.data.payload.errormessage : null
        }))
        .catch(({ data }) => Object.assign({ result: false }, data));
}

export function validateRegion(order) {
    return transformResponse(api.order.validateStep({
        region: order.get('region'),
        step: 'REGION_SELECTOR',
    }));
}

export function validateService(order) {
    return transformResponse(api.order.validateStep({
        region_id: order.get('region'),
        service_id: order.get('service'),
        step: 'SERVICE_SELECTOR',
    }));
}

export function validatePosition(order) {
    return transformResponse(api.order.validateStep({
        region: order.get('region'),
        positions: order.get('positions').toJS(),
        service: { id: order.get('service') },
        step: 'POSITION_SHEET',
    }));
}

export function validateShipping(order) {
    return transformResponse(api.order.validateStep({
        region: order.get('region'),
        service: { id: order.get('service') },
        positions: order.get('positions').toJS(),
        location: order.get('location'),
        billing: order.get('billing'),
        step: 'SHIPPING_SELECTOR',
    }));
}

export function validateAdditions(order) {
    return transformResponse(api.order.validateStep({
        ...transformForApiRequest(order),
        step: 'ADDITIONS',
    }));
}

export default {
    position: validatePosition,
    region: validateRegion,
    service: validateService,
    shipping: validateShipping,
    additions: validateAdditions,
};
